import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-marquee-boxer-item';

const html = `
<div data-use-custom-width="true" data-custom-width="1204" class="container" data-attribute="container-content"
  style="--custom-width: 1204px;">
  <div class="wrap-card">
    <div data-show="true" data-attribute="card-title" class="card-title" style="display: block;">
      <h2 style="text-align: center;">TitanBoxers</h2>
      <p style="text-align: center;">TitanBoxers are the best boxers on the market. They are made with the best
        materials and are designed to fit
        your body perfectly.</p>
    </div>
    <div data-col-per-view="4" data-speed="25" data-space-between="30" data-background-item="#eff3fa"
      data-radius-item="10" data-item-gap="30" data-item-width="300" data-attribute="block-marquee"
      class="block-marquee"
      style="--space-between: 30px; --col-per-view: 4; --border-radius: 10px; --speed: 25s; --item-width: 300px; --item-gap: 30px; --bg-item-color: #eff3fa;">
      <div data-attribute="list-item" class="list-item">
        <div data-attribute="item" class="item-marquee">
          <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f412a57828f6d78447b2.png" alt="" />
            </div>
            <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
            </div>
            <div data-attribute="description-item" data-show="false" class="description-item">
            </div>
          </a>
        </div>
        <div data-attribute="item" class="item-marquee">
          <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f41aad7e435002ab8ebc.png" alt="" />
            </div>
            <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
            </div>
            <div data-attribute="description-item" data-show="false" class="description-item">
            </div>
          </a>
        </div>
        <div data-attribute="item" class="item-marquee">
          <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f422adde14488b4a47d7.png" alt="" />
            </div>
            <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
            </div>
            <div data-attribute="description-item" data-show="false" class="description-item">
            </div>
          </a>
        </div>
        <div data-attribute="item" class="item-marquee">
          <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f427fabfb2495b98b6d5.png" alt="" />
            </div>
            <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
            </div>
            <div data-attribute="description-item" data-show="false" class="description-item">
            </div>
          </a>
        </div>
        <div data-attribute="item" class="item-marquee">
          <a href="#" data-attribute="link-item" target="_blank" class="wrap-item">
            <div class="wrap-img">
              <img data-attribute="image-item"
                src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0f427fabfb2495b98b6d5.png" alt="" />
            </div>
            <div data-attribute="wrap-rating" data-show="true" data-value="4" class="wrap-rating">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>star</title>
                <path
                  d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"
                  fill="currentColor" />
              </svg>
            </div>
            <div data-attribute="description-item" data-show="false" class="description-item">
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
